<template>
  <div class="c-modal">
    <div class="c-container">
      <div class="headerLinks">
        <a @click="$emit('close')" class="closeComment">{{ t("closeAdDocument") }}</a>
      </div>
      <p>{{ t("addAComment") }}</p>
      <form @submit.prevent>
        <textarea data-cy="cyCommentTextArea" v-model.trim="comment"></textarea>
        <button data-cy="cyAddCommentButton" @click="addComment()" :disabled="comment == ''" class="button">{{ t("addComment") }}</button>
      </form>
    </div>
  </div>
</template>

<script lang="ts">
import { reactive, toRefs } from "vue";
import { useI18n } from '@/engineproject/default/common/i18n';
import { AdDocumentProjectTypes } from '@/engineproject/default/common/domainModel/adDocumentProjectTypes';

import { useDocumStore } from '@/engineproject/store/documStore'
import { useUserStore } from '@/engineproject/store/userStore'
import { useAppStore } from '@/engineproject/store/appStore'

export default {
  props: {
    aAdDoc: {
      type: Object as () => AdDocumentProjectTypes.AdDocument,
      required: true
    }
  },
  setup(props: any, context: any) {
    const documeStore = useDocumStore()
    const userStore = useUserStore()
    const appStore = useAppStore()
    const {t} = useI18n()
    const page = reactive({
      comment: '',
      ACContentAdded: false,
    });

    const addComment = async () => {
      // create comment
      if (props.aAdDoc === undefined || page.comment === "") {
        return
      }
      const res = await documeStore.dispatch('addCommentToAdDoc', {
        aAdDoc: props.aAdDoc,
        ACContent: page.comment,
        aUserProfile: userStore.state.aUserProfile,
        appStore: appStore
      })
      if (res === true) {
        // close modal
        context.emit('close', {commentAdded: true})
      }
    }

    return {
      ...toRefs(page),
      t,
      addComment,
    }
  },
}


</script>
